import React, { useContext, useEffect, useState } from 'react'
import { CustomButton, InputWrapper } from '../../../components'
import { toMenuOptions, WemoloDropdown } from '../../../components/Wemolo'
import { TrajectoryConfigurationContext } from './TrajectoryConfigurationContext'
import FilterCreator3000 from './components/FilterCreator3000/FilterCreator3000'
import { StationTrajectoryPanel } from './components/StationTrajectoryPanel'
import { useFlags } from 'launchdarkly-react-client-sdk'
import styles from './FilterTool.module.css'

export const FilterTool = () => {
    const { enableTurnFilter } = useFlags()
    const trajectoryConfigurationContext = useContext(TrajectoryConfigurationContext)

    const filterOptions = [
        ...trajectoryConfigurationContext.filterData.map((filter: any, index: number) => ({
            label: `Filter ${index}`,
            id: `${index}`
        })),
        {
            label: 'Unselect Filter',
            id: 'unselect'
        }
    ]

    const [currentFilterValue, setCurrentFilterValue] = useState<any | null | undefined>()
    const [currentPriorityValue, setCurrentPriorityValue] = useState<any | null | undefined>()
    const [currentTypeValue, setCurrentTypeValue] = useState<any | null | undefined>()
    //
    useEffect(() => {
        if (
            trajectoryConfigurationContext.currentFilter !== undefined &&
            trajectoryConfigurationContext.currentFilter !== null &&
            trajectoryConfigurationContext.filterData
        ) {
            setCurrentFilterValue({
                label: trajectoryConfigurationContext.currentFilter,
                id: trajectoryConfigurationContext.currentFilter
            })
            setCurrentPriorityValue({
                label: trajectoryConfigurationContext.filterData[trajectoryConfigurationContext.currentFilter].priority,
                id: trajectoryConfigurationContext.filterData[trajectoryConfigurationContext.currentFilter].priority
            })
            setCurrentTypeValue({
                label: trajectoryConfigurationContext.filterData[trajectoryConfigurationContext.currentFilter].type,
                id: trajectoryConfigurationContext.filterData[trajectoryConfigurationContext.currentFilter].type
            })
        } else {
            setCurrentFilterValue({
                label: 'please select a filter',
                id: undefined
            })
            setCurrentPriorityValue({
                label: 'no filter selected',
                id: undefined
            })
            setCurrentTypeValue({
                label: 'no filter selected',
                id: undefined
            })
        }
    }, [trajectoryConfigurationContext.currentFilter, trajectoryConfigurationContext.filterData])
    return (
        <div className={styles.root}>
            <div className={styles.leftPanel}>
                <StationTrajectoryPanel>
                    <div className={styles.controls}>
                        <div>
                            <InputWrapper label="Inspect and Edit Filters">
                                <WemoloDropdown
                                    size="medium"
                                    placeholder="please select a filter"
                                    options={toMenuOptions(filterOptions)}
                                    value={currentFilterValue?.id}
                                    onChange={(id) => {
                                        if (typeof id !== 'string') return
                                        if (id === 'unselect') {
                                            trajectoryConfigurationContext.setCurrentFilter(undefined)
                                        } else {
                                            trajectoryConfigurationContext.setCurrentFilter(Number(id))
                                        }
                                    }}
                                />
                            </InputWrapper>
                            <CustomButton
                                onClick={() => {
                                    trajectoryConfigurationContext.addNewFilter()
                                }}
                                extraProps={{ minWidth: '100% !important;' }}
                            >
                                Add New Filter
                            </CustomButton>
                            <CustomButton
                                onClick={() => {
                                    if (window.confirm('Are you sure you want to delete this filter ?')) {
                                        if (
                                            trajectoryConfigurationContext.currentFilter !== undefined &&
                                            trajectoryConfigurationContext.currentFilter !== null
                                        ) {
                                            trajectoryConfigurationContext.deleteFilter(
                                                trajectoryConfigurationContext.currentFilter
                                            )
                                        }
                                    }
                                }}
                                extraProps={{
                                    minWidth: '100% !important;',
                                    marginTop: '16px',
                                    marginBottom: '10px'
                                }}
                                disabled={
                                    trajectoryConfigurationContext.currentFilter === null ||
                                    trajectoryConfigurationContext.currentFilter === undefined
                                }
                            >
                                Delete Filter
                            </CustomButton>
                            <InputWrapper label="Filter Priority">
                                <WemoloDropdown
                                    size="medium"
                                    placeholder="Select Filter Priority"
                                    options={[
                                        { label: '1', value: '1' },
                                        { label: '2', value: '2' },
                                        { label: '3', value: '3' },
                                        { label: '4', value: '4' },
                                        { label: '5', value: '5' }
                                    ]}
                                    value={currentPriorityValue?.id ? String(currentPriorityValue.id) : undefined}
                                    onChange={(id) => {
                                        if (typeof id !== 'string') return
                                        if (
                                            trajectoryConfigurationContext.currentFilter !== undefined &&
                                            trajectoryConfigurationContext.currentFilter !== null
                                        ) {
                                            trajectoryConfigurationContext.setFilterData(
                                                'priority',
                                                id,
                                                trajectoryConfigurationContext.currentFilter
                                            )
                                        }
                                    }}
                                />
                            </InputWrapper>
                            <InputWrapper label="Filter Type">
                                <WemoloDropdown
                                    size="medium"
                                    options={[
                                        {
                                            label: 'FilterInvalidTrajectory_Soft',
                                            value: 'FilterInvalidTrajectory_Soft'
                                        },
                                        { label: 'ClassifyDirection_IN_Soft', value: 'ClassifyDirection_IN_Soft' },
                                        { label: 'ClassifyDirection_OUT_Soft', value: 'ClassifyDirection_OUT_Soft' },
                                        {
                                            label: 'FilterInvalidTrajectory_Double',
                                            value: 'FilterInvalidTrajectory_Double'
                                        },
                                        ...(enableTurnFilter ? [{ label: 'FilterTurn', value: 'FilterTurn' }] : [])
                                    ]}
                                    value={currentTypeValue?.id}
                                    onChange={(id) => {
                                        if (typeof id !== 'string') return
                                        if (
                                            trajectoryConfigurationContext.currentFilter === undefined ||
                                            trajectoryConfigurationContext.currentFilter === null
                                        )
                                            return
                                        trajectoryConfigurationContext.setFilterData(
                                            'type',
                                            id,
                                            trajectoryConfigurationContext.currentFilter
                                        )

                                        const currentType =
                                            trajectoryConfigurationContext.filterData[
                                                trajectoryConfigurationContext.currentFilter
                                            ].type
                                        if (id === 'FilterTurn') {
                                            trajectoryConfigurationContext.setFilterData(
                                                'properties',
                                                {},
                                                trajectoryConfigurationContext.currentFilter
                                            )
                                        } else if (
                                            id === 'FilterInvalidTrajectory_Double' &&
                                            (currentType === 'FilterInvalidTrajectory_Soft' ||
                                                currentType === 'ClassifyDirection_IN_Soft' ||
                                                currentType === 'ClassifyDirection_OUT_Soft')
                                        ) {
                                            trajectoryConfigurationContext.setFilterData(
                                                'properties',
                                                {
                                                    _rectangle_in: {},
                                                    _rectangle_in_out: { _x0: 0, _x1: 400, _y0: 0, _y1: 400 },
                                                    _rectangle_out: {}
                                                },
                                                trajectoryConfigurationContext.currentFilter
                                            )
                                        } else if (
                                            (id === 'FilterInvalidTrajectory_Soft' ||
                                                id === 'ClassifyDirection_IN_Soft' ||
                                                id === 'ClassifyDirection_OUT_Soft') &&
                                            currentType === 'FilterInvalidTrajectory_Double'
                                        ) {
                                            trajectoryConfigurationContext.setFilterData(
                                                'properties',
                                                {
                                                    _rectangle_in: { _x0: 0, _x1: 300, _y0: 0, _y1: 300 },
                                                    _rectangle_out: { _x0: 500, _x1: 900, _y0: 400, _y1: 800 }
                                                },
                                                trajectoryConfigurationContext.currentFilter
                                            )
                                        }
                                    }}
                                />
                            </InputWrapper>
                        </div>
                    </div>
                </StationTrajectoryPanel>
            </div>
            <div className={styles.rightPanel}>
                <StationTrajectoryPanel>
                    <FilterCreator3000 />
                </StationTrajectoryPanel>
            </div>
        </div>
    )
}
